$('.confirm-clone').on('click', function (e) {
    e.preventDefault();

    let link = $(this).attr('href');
    let confirmationModal = $('#clone-confirmation-modal');

    confirmationModal.find('.confirm-clone-route').attr('href', link);
    confirmationModal.modal('show');
});
